import React from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { BsCashCoin, BsPiggyBank } from "react-icons/bs";

export default function RapoarteCasa() {
  const navigate = useNavigate();

  return (
    <div className="p-3">
      <Card className="shadow-sm border-0 rounded-4 p-4">
        <h4 className="fw-bold mb-4 text-dark">Rapoarte Casa / Banca</h4>
        <Row className="g-4">
          <Col xs={12} md={6}>
            <Card className="h-100 border border-light-subtle rounded-4 bg-light shadow-sm">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="text-primary mb-3">
                    <BsCashCoin size={40} />
                  </div>
                  <Card.Title className="fw-bold mb-2">Registru de Casă / Bancă</Card.Title>
                  <Card.Text className="text-secondary small">
                    Vizualizează registrul complet de plăți și încasări efectuate prin casierie sau conturile bancare.
                  </Card.Text>
                </div>
                <div className="mt-4">
                  <Button
                    variant="primary"
                    onClick={() => navigate("/cash")}
                    className="fw-semibold px-4 rounded-3"
                  >
                    Mergi la Registru
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col xs={12} md={6}>
            <Card className="h-100 border border-light-subtle rounded-4 bg-light shadow-sm">
              <Card.Body className="p-4 d-flex flex-column justify-content-between">
                <div>
                  <div className="text-info mb-3">
                    <BsPiggyBank size={40} />
                  </div>
                  <Card.Title className="fw-bold mb-2">Raport Zilnic pe Cont (Casa / Bancă)</Card.Title>
                  <Card.Text className="text-secondary small">
                    Generează raportul zilnic pe cont cu sold început zi, înregistrări pe zi și sold sfârșit zi.
                  </Card.Text>
                </div>
                <div className="mt-4">
                  <Button
                    variant="primary"
                    onClick={() => navigate("/rapoarte/casa-zilnic")}
                    className="fw-semibold px-4 rounded-3"
                  >
                    Deschide Raport Zilnic
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Card>
    </div>
  );
}
